import { SET_LOCKED_COUNTRY, SET_SELECT_COUNTRY, SET_SELECT_COUNTRY_2, SET_SELECT_COUNTRY_3 } from "../constants";

export default (state = {
    selectCountry: 'AT',
    selectCountry2: '',
    selectCountry3: '',
    lockedCountry: '',
    isCookie: false,
    selectedByUser: false
}, action) => {
    switch (action.type) {
        case SET_SELECT_COUNTRY:
            return {
                ...state,
                selectCountry: action.payload.country
            }
            
        case SET_SELECT_COUNTRY_2:
            return {
                ...state,
                selectCountry2: action.payload.country2
        }

        case SET_SELECT_COUNTRY_3:
            return {
                ...state,
                selectCountry3: action.payload.country3
        }

        case SET_LOCKED_COUNTRY:
            return {
                ...state,
                lockedCountry: action.payload.country,
                isCookie: action.payload.isCookie,
                selectedByUser: action.payload.selectedByUser
            }
    
        default:
            return state;
    }
}